import { put, takeLatest, all, call, } from 'redux-saga/effects';

//action watcher
function* actionWatcher(){

}

//root saga
export default function* rootSaga(){
    yield all([
        actionWatcher()
    ])
}